import { createContext, useContext, useEffect, useState } from "react";

const ModeContext = createContext(null);

export function ModeProvider({ children }) {
    const [mode, setModeState] = useState(() => localStorage.getItem("homiie_mode") || "services");
    useEffect(() => { localStorage.setItem("homiie_mode", mode); }, [mode]);
    const setMode = (m) => setModeState(m);
    return <ModeContext.Provider value={{ mode, setMode }}>{children}</ModeContext.Provider>;
}

export function useMode() {
    return useContext(ModeContext) || { mode: "services", setMode: () => {} };
}
